import { bucketRange } from '../range/bucket';
import { bucketedToShape } from '../range/shape';
/**
 * Assemble a StrategyContext, deriving hero.equity (vs the villain's continuing range) and
 * villain.rangeShape (bucketed against the board) from the real range. Pure; the only computed fields are
 * `hero.equity` and `villain.rangeShape` - every other field is passed through from the caller's live
 * situation read.
 */
export const assembleLiveContext = (input) => {
    const equity = input.equity.handVsRange(input.hero.cards, input.villain.range, input.board, input.equityIterations !== undefined ? { iterations: input.equityIterations } : undefined).equity;
    const rangeShape = bucketedToShape(bucketRange(input.villain.range, input.board, input.villain.archetype));
    const ctx = {
        street: input.street,
        facing: input.facing,
        positionClass: input.positionClass,
        potType: input.potType,
        playersInHand: input.playersInHand,
        spr: input.spr,
        sprBucket: input.sprBucket,
        textureClass: input.textureClass,
        price: input.price,
        hero: { handClass: input.hero.handClass, drawFlags: input.hero.drawFlags, equity },
        villain: { archetype: input.villain.archetype, rangeShape },
        rules: input.rules,
    };
    if (input.icm)
        ctx.icm = input.icm;
    return ctx;
};
//# sourceMappingURL=liveContext.js.map